import {
  EDITOR_LOAD_EXTERNAL_APIS_BEGIN,
  EDITOR_LOAD_EXTERNAL_APIS_SUCCESS,
  EDITOR_LOAD_EXTERNAL_APIS_FAILURE,
  EDITOR_LOAD_EXTERNAL_APIS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadExternalApis(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_EXTERNAL_APIS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/all/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_EXTERNAL_APIS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_EXTERNAL_APIS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalApisError() {
  return {
    type: EDITOR_LOAD_EXTERNAL_APIS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_EXTERNAL_APIS_BEGIN:
      return {
        ...state,
        loadExternalApisPending: true,
        loadExternalApisError: null,
      };

    case EDITOR_LOAD_EXTERNAL_APIS_SUCCESS:
      return {
        ...state,
        loadExternalApisPending: false,
        loadExternalApisError: null,
        externalApis: action.data,
        showBuilderCanvasLoader: !state.showBuilderCanvasLoader,
      };

    case EDITOR_LOAD_EXTERNAL_APIS_FAILURE:
      return {
        ...state,
        loadExternalApisPending: false,
        loadExternalApisError: action.data.error,
      };

    case EDITOR_LOAD_EXTERNAL_APIS_DISMISS_ERROR:
      return {
        ...state,
        loadExternalApisError: null,
      };

    default:
      return state;
  }
}
